import React, {createContext, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Honeybadger from '@honeybadger-io/js';
import RegistryRetailerApi from '../services/RegistryRetailerApi';

const Context = createContext({
  retailers: [],
  isFetching: true,
});

export default Context;

export const RetailersContextProvider = ({children}) => {
  const [retailers, setRetailers] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    const getRetailers = async () => {
      try {
        const retailersResponse = await RegistryRetailerApi.getRetailers();
        setRetailers(retailersResponse);
        setIsFetching(false);
      } catch (error) {
        setIsFetching(false);

        Honeybadger.notify(error, 'GetRetailersError');
      }
    };

    getRetailers();
  }, []);

  return (
    <Context.Provider value={{retailers, isFetching}}>
      {children}
    </Context.Provider>
  );
};

RetailersContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
